export default __webpack_public_path__ + "90a86fe34c3bc2ccdc7ea733ddbe3a90.png";